import { render, staticRenderFns } from "./dermatology.vue?vue&type=template&id=39f3499a&scoped=true&"
import script from "./dermatology.vue?vue&type=script&lang=js&"
export * from "./dermatology.vue?vue&type=script&lang=js&"
import style0 from "./dermatology.vue?vue&type=style&index=0&id=39f3499a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f3499a",
  null
  
)

export default component.exports